const SET_MSA = 'classpass/sell-experience/SET_MSA';
export const ENABLE_MAP = 'classpass/sell-experience/ENABLE_MAP';
export const SET_SELECTED_STUDIO_ID = 'classpass/sell-experience/SET_SELECTED_STUDIO_ID';
const ADD_ACTIVITY_FILTER = 'classpass/sell-experience/ADD_ACTIVITY_FILTER';
const REMOVE_ACTIVITY_FILTER = 'classpass/sell-experience/REMOVE_ACTIVITY_FILTER';

const initialState = {
  mapEnabled: false,
  msaId: 0,
  selectedStudioId: null,
  activityFilters: [],
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case ENABLE_MAP:
    case SET_SELECTED_STUDIO_ID:
    case SET_MSA:
      return { ...state, [action.data.key]: action.data.value };
    case ADD_ACTIVITY_FILTER:
      return { ...state, activityFilters: state.activityFilters.concat([action.data]) };
    case REMOVE_ACTIVITY_FILTER:
      return { ...state, activityFilters: state.activityFilters.filter(activity => activity !== action.data) };
    default:
      return state;
  }
}

export const setMsaId = msaId => ({ type: SET_MSA, data: { key: 'msaId', value: parseInt(msaId, 10) || 0 } });
export const enableMap = () => ({ type: ENABLE_MAP, data: { key: 'mapEnabled', value: true } });
export const setSelectedStudioId = studioId => ({
  type: SET_SELECTED_STUDIO_ID,
  data: { key: 'selectedStudioId', value: studioId },
});
export const addActivityFilter = activity => ({ type: ADD_ACTIVITY_FILTER, data: activity });
export const removeActivityFilter = activity => ({ type: REMOVE_ACTIVITY_FILTER, data: activity });

export const selectMsaId = state => state.features.homepage.msaId;
